import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
  timeout: 15000,
});

// Attach bearer token (fallback for browsers that drop cookies) on every request.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Silent token refresh: on 401, refresh once via the refresh_token cookie and retry.
let refreshPromise = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const url = original?.url || "";
    if (
      status === 401 &&
      original &&
      !original._retry &&
      !url.includes("/auth/login") &&
      !url.includes("/auth/refresh")
    ) {
      original._retry = true;
      try {
        if (!refreshPromise) {
          refreshPromise = api.post("/auth/refresh").finally(() => { refreshPromise = null; });
        }
        const { data } = await refreshPromise;
        if (data?.access_token) localStorage.setItem("rl_token", data.access_token);
        return api(original);
      } catch (e) {
        localStorage.removeItem("rl_token");
        if (
          typeof window !== "undefined" &&
          !window.location.pathname.startsWith("/login") &&
          !window.location.pathname.startsWith("/anmeldung/") &&
          !window.location.pathname.startsWith("/freigabe/") &&
          !window.location.pathname.startsWith("/drop/") &&
          !window.location.pathname.startsWith("/design-anfrage") &&
          !window.location.pathname.startsWith("/design-antwort/") &&
          !window.location.pathname.startsWith("/buchen") &&
          !window.location.pathname.startsWith("/upload/") &&
          !window.location.pathname.startsWith("/datenschutz") &&
          !window.location.pathname.startsWith("/datenloeschung") &&
          !window.location.pathname.startsWith("/nutzungsbedingungen")
        ) {
          window.location.href = "/login";
        }
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  },
);

export function setAuthToken(token) {
  if (token) localStorage.setItem("rl_token", token);
  else localStorage.removeItem("rl_token");
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
